var render = function render(){var _vm=this,_c=_vm._self._c;return _c('detail',{attrs:{"on-manager":_vm.onManager,"data":_vm.itemData,"base-info":_vm.baseInfo,"extra-info":_vm.extraInfo,"resource":"hosts","status-module":"host"}})
}
var staticRenderFns = []

export { render, staticRenderFns }